import type { AnimalGroupDto, OrganizationDto } from "@strtmn/sds/types"
import config from "../../../config"
import { getLinkToOrgAnimalGroup } from "../../../LinkUtils"
import { imageHash, ListItem, StarStates } from "./ListItem"

const NUM_AG_IMAGES = config.images.ag.numImages
const IMAGE_HASH_SEED = config.images.ag.imageHashSeed

interface AnimalGroupProps {
  className?: string
  org: OrganizationDto
  item: AnimalGroupDto
  extraDetails?: string | React.ReactNode
  hasViewButton?: boolean
  hasEditButton?: boolean
  hideFavStar?: boolean
}

/**
 * A ListItem representing an Animal Group.
 * Used in
 *   - /animal-groups/
 *     - animal count
 *   - /recipes/:recipeId
 *     - animal count
 *     - extraDetails: total weight (of recipeId for this group)
 * @returns
 */
export default function AnimalGroupItem({
  className,
  org,
  item,
  extraDetails,
  hasViewButton = true,
  hasEditButton = false,
  hideFavStar = false,
}: AnimalGroupProps) {
  /** @todo Hide favorites for Eurotier */
  hideFavStar = true
  const a = item as AnimalGroupDto
  const imageIdx = imageHash(IMAGE_HASH_SEED, a.id, NUM_AG_IMAGES)
  const imageSrc = `/images/ag/animals-pixabay-${imageIdx}_s.jpg`
  const detailsContent = `${a.number_of_animals} Tiere`
  let details
  if (!extraDetails) {
    details = detailsContent
  } else {
    details =
      "string" === typeof extraDetails ? (
        detailsContent + extraDetails
      ) : (
        <>
          <div>{detailsContent}</div>
          {extraDetails}
        </>
      )
  }
  return (
    <ListItem
      key={a.id}
      className={`animal-group ${className}`}
      title={a.name}
      href={getLinkToOrgAnimalGroup(org, a.id, false)}
      imageSrc={imageSrc}
      details={details}
      hasViewButton={hasViewButton}
      hasEditButton={hasEditButton}
      starState={hideFavStar ? StarStates.hidden : StarStates.empty}
    />
  )
}
